import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import MetaSummary from "../../../ui/components/MetaSummary/MetaSummary";

import SerieMetaDataEdit from "../SerieMetaDataEdit/SerieMetaDataEdit";

export default function SerieMetaData({ serie, publisher }) {
	const { t } = useTranslation();
	const [edit, setEdit] = useState(false);

	const createdBy = serie.createdBy?.email ? serie.createdBy?.name : "Astrid";

	const fields = [
		{
			label: t("description", "Description"),
			value: serie.description,
			style: { flex: "0 0 100%" },
		},
		{
			label: t("created", "Created"),
			value: `${serie.created?.toDate().toLocaleDateString()} by ${createdBy}`,
			style: { flex: "0 0 100%" },
		},
	];

	return (
		<>
			<MetaSummary onEdit={() => setEdit(true)} left={fields} />

			{edit && <SerieMetaDataEdit serie={serie} publisher={publisher} onClose={() => setEdit(false)} />}
		</>
	);
}
